var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("circle", {
  id: "Ellipse",
  cx: 6.31836,
  cy: 6,
  r: 6,
  fill: "#D9D9D9"
});

var _ref3 = /*#__PURE__*/React.createElement("g", {
  mask: "url(#mask0_5605_3089)"
}, /*#__PURE__*/React.createElement("rect", {
  id: "Fill",
  x: -0.226562,
  y: -0.544922,
  width: 13.0909,
  height: 13.0909,
  fill: "#DC362E"
}));

var _ref4 = /*#__PURE__*/React.createElement("g", {
  id: "Shape"
}, /*#__PURE__*/React.createElement("path", {
  d: "M6.01626 2.76062C6.11132 2.71875 6.21407 2.69718 6.31795 2.69727C6.42176 2.69729 6.52442 2.71895 6.61939 2.76087C6.71436 2.80278 6.79955 2.86403 6.86953 2.9407C6.93951 3.01738 6.99273 3.1078 7.02582 3.20619C7.0589 3.30459 7.07112 3.4088 7.06168 3.51217L6.76386 6.78981C6.75228 6.90001 6.70031 7.00201 6.61797 7.07615C6.53563 7.1503 6.42875 7.19132 6.31795 7.19132C6.20715 7.19132 6.10027 7.1503 6.01793 7.07615C5.93559 7.00201 5.88362 6.90001 5.87204 6.78981L5.57341 3.51217C5.56396 3.40873 5.5762 3.30445 5.60933 3.206C5.64246 3.10755 5.69577 3.01709 5.76583 2.9404C5.8359 2.86372 5.92119 2.80248 6.01626 2.76062Z",
  fill: "white"
}), /*#__PURE__*/React.createElement("path", {
  d: "M7.0317 8.59022C7.0317 8.9844 6.71216 9.30394 6.31798 9.30394C5.92381 9.30394 5.60426 8.9844 5.60426 8.59022C5.60426 8.19605 5.92381 7.8765 6.31798 7.8765C6.71216 7.8765 7.0317 8.19605 7.0317 8.59022Z",
  fill: "white"
}));

function SvgValidateFail(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 13,
    height: 12,
    viewBox: "0 0 13 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "Group 12424"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Mask group"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_5605_3089",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 13,
    height: 12
  }, _ref2), _ref3), _ref4));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgValidateFail);
export default __webpack_public_path__ + "static/media/validate-fail.6e048efa.svg";
export { ForwardRef as ReactComponent };